// import { Component, OnInit } from '@angular/core';

// @Component({
//   selector: 'app-raport-incasari-table',
//   templateUrl: './raport-incasari-table.component.html',
//   styleUrls: ['./raport-incasari-table.component.scss']
// })
// export class RaportIncasariTableComponent implements OnInit {

//   constructor() { }

//   ngOnInit(): void {
//   }

// }

import {
  Component,
  OnInit,
  ViewChildren,
  QueryList,
  ViewChild,
  ElementRef,
  Input,
  EventEmitter,
  Output
} from '@angular/core';

import { Store, select } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { ApplicationState } from 'src/app/modules/acbcr/common/state/app.state';
import { getCurrentRoute } from 'src/app/modules/acbcr/common/state/reducers/route.reducers';
import { HelperDataService } from 'src/app/modules/acbcr/common/services/helper-data.service';
import { AdvancedSortableDirective, SortEvent } from 'src/app/modules/acbcr/directives/advanced-sortable.directive';
import { RaportIncasare } from 'src/app/modules/acbcr/common/models/rapoarte-incasari.model';
import { RapoarteIncasariTableService } from 'src/app/modules/acbcr/common/services/rapoarte-incasari.service';
import { UIHelper } from 'src/app/modules/acbcr/components/common/helper/ui-helper';
import { RapoarteContabilitateTableService } from 'src/app/modules/acbcr/common/services/contabilitate-rapoarte.service';

@Component({
  selector: 'app-raport-incasari-table',
  templateUrl: './raport-incasari-table.component.html',
  styleUrls: ['./raport-incasari-table.component.scss']
})
export class RaportIncasariTableComponent implements OnInit {
  @ViewChildren(AdvancedSortableDirective) headers: QueryList<
  AdvancedSortableDirective>;
  @ViewChild('rapoarteIncasariTable', { static: false }) rapoarteIncasariTable: ElementRef;

  @Input() rapoarteIncasari: any[];
  @Input() rapoarteIncasariLength: number;
  @Input() loadingDataSpinner: boolean;
  @Input() totalRestant;

  @Output() filterData = new EventEmitter();
  @Output() exportData = new EventEmitter();
  @Output() pageSizeChanged = new EventEmitter();
  @Output() pageNumberChanged = new EventEmitter();
  @Output() rapoarteIncasariTableCallback = new EventEmitter();

  readonly modalType = 'rapoarte-conta-incasari';
  openSearchModal = new Subject<boolean>();

  currentRoute: string;
  destroy$: Subject<boolean> = new Subject<boolean>();
  isAutoritateJudeteana = false;
  isContabil = false;
  filteredRapoarte;
  isDataFiltered = false;

  constructor(
    public rapoarteContabilitateTableService: RapoarteContabilitateTableService,
    private store: Store<ApplicationState>,
    private helperDataService: HelperDataService,
  ) { }

  ngOnInit(): void {
    this.store.pipe(select(getCurrentRoute))
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: string) => {
        this.currentRoute = response;
      });
    this.isAutoritateJudeteana = UIHelper.isAutoritateJudeteana();
    this.isContabil = UIHelper.isContabil();
  }

  onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.rapoarteContabilitateTableService.sortColumn = column;
    this.rapoarteContabilitateTableService.sortDirection = direction;
  }

  changeTableRows(event) {
    this.pageSizeChanged.emit(event.target.value);
  }

  changeTablePage(event) {
    this.pageNumberChanged.emit(event);
  }

  openTableSearchModal() {
    this.openSearchModal.next(true);
  }

  filterSearch(event) {
    this.filterData.emit(event);
    this.filteredRapoarte = event;
    // check if a filter was made
    this.isDataFiltered = !Object.values(this.filteredRapoarte).every(
      (o) => o === null
    );
  }

  exportTableXLSX() {
    this.exportData.emit(null);
  }

  getModalResult(event) {
    this.rapoarteIncasariTableCallback.emit(event);
  }

}
